import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import ErrorOutlineOutlinedIcon from "@material-ui/icons/ErrorOutlineOutlined";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";

import useMediaQuery from "../../hooks/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      width: theme.spacing(13),
    },
    textAlign: "start",
    marginTop: "10px",
  },
  containerWidget: {
    width: 160,
    height: 80,
    display: "flex",
  },
  containerWidgetResponsive: {
    width: 160,
    height: 80,
    display: "flex",
  },
  containerIcon: {
    width: 50,
    height: "100%",
    textAlign: "center",
  },
  containerLabels: {
    width: "100%",
    height: "100%",
    textAlign: "start",
  },
  containerLabelsResponsive: {
    width: "100%",
    height: "100%",
    textAlign: "start",
  },
  pValue: {
    margin: 0,
    padding: 0,
    fontSize: "24px",
    color: "#12B1EE",
    font: "Regular 32px/38px Roboto",
    fontWeight: 400,
  },
  pDescription: {
    margin: 0,
    marginTop: 1,
    padding: 0,
    fontSize: "13px",
    color: "#707070",
    opacity: 1,
    font: "Regular 14px/16px Roboto",
  },
  icon: {
    color: "#12B1EE",
    fontSize: "28px",
    marginTop: "5px",
  },
}));

const Widget = (props) => {
  const { value, descripcion, currency, icon } = props;
  const classes = useStyles();

  const isMobile = useMediaQuery("max-width", 600);

  return (
    <div className={classes.root}>
      <Paper elevation={0}>
        <div className={classes.containerWidget}>
          <div className={classes.containerIcon}>
            {icon === "calendar" ? (
              <DateRangeOutlinedIcon className={classes.icon} />
            ) : icon === "money" ? (
              <MonetizationOnOutlinedIcon className={classes.icon} />
            ) : icon === "file" ? (
              <DescriptionOutlinedIcon className={classes.icon} />
            ) : icon === "error" ? (
              <ErrorOutlineOutlinedIcon className={classes.icon} />
            ) : (
              ""
            )}
          </div>
          <div
            className={
              !!isMobile
                ? classes.containerLabels
                : classes.containerLabelsResponsive
            }
          >
            <div>
              <p className={classes.pValue}>
                {!value ? "No hay dato" : currency + value}
              </p>
            </div>
            <div>
              <p className={classes.pDescription}>
                {!descripcion ? "No hay dato" : descripcion}
              </p>
            </div>
          </div>
        </div>
      </Paper>
    </div>
  );
};

export default Widget;
